import { useEffect, useState } from 'react'
import { useExperiment } from '../../../lib/hooks/useExperiment'
import { Size } from '../../../types/system'
import { ButtonHierarchy } from '../Button'
import { InternalLink } from '../Link'
import styles from './debug-widget.module.scss'
import { isProd } from '@/lib/utilities/system'

export const DebugWidget = () => {
  const [experimentGroup] = useExperiment()
  const [showDebug, setShowDebug] = useState(false)

  useEffect(() => {
    setShowDebug(!isProd())
  }, [])

  if (!showDebug) {
    return false
  }

  return (
    <InternalLink
      hasBackground
      hasPadding
      size={Size.ExtraSmall}
      className={styles.main}
      href={'/debug'}
      icon="FlaskConical"
      hierarchy={ButtonHierarchy.BezeledGray}>
      {experimentGroup}
    </InternalLink>
  )
}
